export const HOPE_ORG_NAME = "H.O.P.E.";
export const HOPE_ORG_FULL = "Healed Ones Providing Empathy";

export const HOPE_NAMING_EXPLAINER = `Hope is named after ${HOPE_ORG_NAME} — ${HOPE_ORG_FULL} — the team built around this work.`;
